<template>
    <div class="m-macro-rank-mini m-macro-rank" v-loading="loading">
        <h3 class="m-side-title">
            <div class="u-title"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" v-bind:class="'u-icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="#ffa91e"><path d="M324.891 167.266l16.262 94.815L256 217.314l-85.153 44.767 16.262-94.815-68.891-67.16 95.205-13.833L256 0l42.577 86.273 95.205 13.833z"/><path d="M409.944 253.46v87.673L256.9 403.303l-.9-.36-153.944-61.76V253.46L256 315.219z"/><path d="M409.944 362.157v87.673L256.9 512l-.9-.36-153.944-61.76v-87.723L256 423.916z"/></g><g fill="#ff8900"><path d="M341.153 262.081L256 217.314V0l42.577 86.273 95.205 13.833-68.891 67.16zM409.944 253.46v87.673L256.9 403.303l-.9-.36v-87.724zM256 423.916l153.944-61.759v87.673L256.9 512l-.9-.36z"/></g></svg>排行榜</div>
            <span class="u-more" @click="viewRank">查看更多<i class="el-icon-d-arrow-right"></i></span>
        </h3>
        <ul class="u-list" v-if="subtype">
            <li v-for="(item, j) in mount_data" :key="j">
                <a
                    class="u-link"
                    :href="getMacroLink(item.pid, item.item_version)"
                    v-reporter="{
                        data: {
                            href: macroLink(getMacroLink(item.pid, item.item_version)),
                        },
                        caller: 'macro_rank_top',
                    }"
                >
                    <span class="u-order" :class="highlight(j)">{{ j + 1 }}</span>
                    <span class="u-name">{{ item.author }}#{{ item.item_version }}</span>
                    <span class="u-per">
                        <em class="u-count"><i class="el-icon-sunny"></i> {{ item.value["7days"] }}</em>
                    </span>
                </a>
            </li>
        </ul>
        <ul class="u-list" v-else>
            <li v-for="(item, j) in data" :key="j">
                <a
                    class="u-link"
                    :href="getMacroLink(item.pid, item.v)"
                    v-reporter="{
                        data: {
                            href: macroLink(getMacroLink(item.pid, item.v)),
                            item_type: item.xf
                        },
                        caller: 'macro_rank_top',
                    }"
                >
                    <span class="u-order" :class="highlight(j)">{{ j + 1 }}</span>
                    <span class="u-name">{{ item.author }}#{{ item.v }}</span>
                    <span class="u-per">
                        <em class="u-count"><i class="el-icon-sunny"></i> {{ item["7days"] }}</em>
                    </span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import { getOverview, getRank } from "../../service/rank";
import xfmap from "@jx3box/jx3box-data/data/xf/xf.json";
import { getLink } from "@jx3box/jx3box-common/js/utils";
import { getMacroLink } from "@/utils/misc.js";
export default {
    name: "rank",
    data: function () {
        return {
            data: [],
            mount_data: [],
            loading: false,
        };
    },
    computed: {
        subtype: function () {
            return this.$route.query.subtype || "";
        },
        // kungfuid: function () {
        //     return this.subtype ? xfmap[this.subtype]["id"] : -1;
        // },
        client: function () {
            return this.$store.state.client;
        },
    },
    methods: {
        viewRank: function () {
            this.$router.push({ name: "rank" });
        },
        highlight: function (i) {
            if (i == 0) {
                return "t1";
            } else if (i == 1) {
                return "t2";
            } else if (i == 2) {
                return "t3";
            }
        },
        getMacroLink,
        macroLink(link) {
            const prefix = this.client == 'std' ? 'www' : 'origin';
            return `${prefix}:${link}`
        },
    },
    watch: {
        subtype: {
            immediate: true,
            handler: function (subtype) {
                this.loading = true;
                if (subtype) {
                    getRank(this.subtype, this.client, 10)
                        .then((data) => {
                            this.mount_data = data.slice(0, 10);
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                } else {
                    getOverview(this.client, 10)
                        .then((data) => {
                            this.data = data.slice(0, 10);
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            },
        },
    },
    mounted: function () {},
    components: {},
};
</script>

<style lang="less">
@import "~@/assets/css/rank.less";
</style>
